<template>
  <div class="v-concretes">
    <iframe
      class="v-concretes__frame"
      ref="concrete"
      :src="concreteUrl"
      tabindex="0"
    ></iframe>
  </div>
</template>

<script>
import { computed, onMounted, onBeforeUnmount } from '@vue/composition-api'

export default {
  name: 'Concretes',

  components: {},

  setup(props, ctx) {
    const concreteUrl = computed(() => {
      const url = process.env.VUE_APP_CONCRETES_URL
      return `${url}/${ctx.root.$route.params.slug}`
    })

    function handleMessage(event) {
      switch (event.data) {
        case 'back':
          ctx.root.$router.push({ name: 'Overview' })
          break
        default:
          break
      }
    }

    onMounted(() => {
      window.addEventListener('message', handleMessage)
    })

    onBeforeUnmount(async () => {
      window.removeEventListener('message', handleMessage)
    })

    return {
      concreteUrl,
    }
  },
}
</script>
